import { fareType } from "src/containers/chart/types";

export const getFareInitialObj = (initialVal: string | number | unknown = "") =>
  Object.keys(fareType).reduce(
    (acc, cur) => ({ ...acc, [cur]: initialVal }),
    {}
  );

export const initialState = {
  chartData: null,
  loading: "",
  errMsg: false,
  selectedSeats: [],
  fareBreakup: {
    fare: getFareInitialObj(0),
    fareCategory: getFareInitialObj(),
    fareLabel: getFareInitialObj(),
    seats: 0,
  },
  selectedPickup: null,
  selectedDropoff: null,
  showSeatLayout: false,
};
